import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const downloadReportThunk = createAsyncThunk(
  "report/download",
  async ({ api, data }, thunkAPI) => {
    try {
      const authToken = JSON.parse(localStorage.getItem("user_auth_token"));

      const response = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to download report");
      }

      // Convert to blob (binary data)
      const blob = await response.blob();
       const now = new Date();
      const timestamp = `${now.getFullYear()}${(now.getMonth() + 1)
        .toString()
        .padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now
          .getHours()
          .toString()
          .padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now
            .getSeconds()
            .toString()
            .padStart(2, "0")}`;
      // Create a download link and trigger it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${timestamp}_MHA_Report.pdf`; // optional default filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      console.error("Download error: ", error);
      return thunkAPI.rejectWithValue(error.message || "Download failed");
    }
  }
);


export const reportSlice = createSlice({
  name: "report",
  initialState: { loading: false, error: null,success:false },
  extraReducers: (builder) => {
    builder
      .addCase(downloadReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success=false;
      })
      .addCase(downloadReportThunk.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(downloadReportThunk.rejected, (state) => {
        state.loading = false;
        state.error = true;
        state.success=false;
      });
  },
});

export default reportSlice.reducer;
